import { render, staticRenderFns } from "./ImageModerationModelsTab.vue?vue&type=template&id=b866e122&"
import script from "./ImageModerationModelsTab.vue?vue&type=script&lang=js&"
export * from "./ImageModerationModelsTab.vue?vue&type=script&lang=js&"
import style0 from "./ImageModerationModelsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports